module.exports = __webpack_public_path__ + "media/locales/_de-cc23f204.png";